import { render, staticRenderFns } from "./custom-date-picker.vue?vue&type=template&id=0c7c3a3c&scoped=true&class=calendar-picker&"
import script from "./custom-date-picker.vue?vue&type=script&lang=ts&"
export * from "./custom-date-picker.vue?vue&type=script&lang=ts&"
import style0 from "./custom-date-picker.vue?vue&type=style&index=0&id=0c7c3a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c3a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
